import { type CSSResultGroup, css, unsafeCSS } from "lit";

// Chosen on advice from https://modernfontstacks.com
export const fontFamily =
    'ui-monospace, "Cascadia Code", "Source Code Pro", Menlo, Consolas, "DejaVu Sans Mono", monospace';
export const fontFamilyCSS = unsafeCSS(fontFamily);

export const taskStyles: CSSResultGroup = [
    css`
.result-label {
    margin-bottom: 20px;
}
.container-centered {
   display: flex;
   justify-content: center;
}

/* Text */
term,
green {
   color: var(--sl-color-green-500);
   padding: 2px;
   font-weight: bold;
}

note {
   color: var(--sl-color-primary-500);
}

blue {
   color: var(--sl-color-primary-500);
}

warning,
orange {
   color: var(--sl-color-orange-500);
}

danger {
   color: var(--sl-color-red-500);
}

code {  /* Used in shell course */
  background-color: rgb(66, 90, 115);
  padding: 2px 3px 1px 3px;
  font-family: var(--whilecat-default-font-mono);
  font-size: 12px;
  border-radius: 4px;
}

/* Tables */
table {
   width: 100%;
   overflow-x: auto;
   border-collapse: collapse;
}

thead {
   display: table-header-group;
   vertical-align: middle;
   unicode-bidi: isolate;
   border-color: inherit;
}

table th,
table td {
   line-height: var(--sl-line-height-normal);
   text-align: left;
   padding-left: 10px;
   color: var(--whilecat-light-3);
}

.table-header {
  min-width: 15ch;
  font-size: 16px;
  color: var(--whilecat-light-2);
}

table tr {
    border-bottom: solid 1px var(--whilecat-dark-1);
    padding-bottom: 10px;
}
`,
];
